/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для сообщения о невозможности заказать товары транзиты.
   */
  app.CartTransitMessageView = app.View.extend({
    el: '.js-comment_cart',
    events: {
      'click .js-close': 'hide',
    },

    /**
     * @inheritDoc
     */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#cart-transit-message-template');
      this.render();
      this.listenTo(this.settlement, 'sync', this.render);
      this.listenTo(this.cart, 'sync', this.render);
      this.listenTo(Backbone, 'DeleteItemFromCart', this.render);
    },

    /**
     * Рендер суммы для разметки
     */
    render: function () {
      this.$el.html(this.isTransitUnavailable() ? this.template() : '');
    },

    /**
     * Проверка есть ли недоступный транзитный товар в корзине.
     * @returns {boolean} Признак, есть ли недоступный транзитный товар.
     */
    isTransitUnavailable: function () {
      var transitSettlements = this.cart.transit_settlements;
      var settlementId = this.settlement.get('settlement_id');
      var isTransitSettlement = transitSettlements && transitSettlements.indexOf(settlementId) !== -1;
      return Boolean(transitSettlements && transitSettlements.length && !isTransitSettlement);
    },

    /**
     * Скрытие блока допродажи
     */
    hide: function() {
      this.$el.addClass('not_display');
    },
  });
})(jQuery);

}.call(window));